




// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import "../styles/RdDdReport.css";

// const secondaryTabs = ["All", "Active", "Closed", "Pre-Closed", "Reject"];
// const rowsPerPage = 10;

// const RdDdReport = () => {
//   const [activeMainTab, setActiveMainTab] = useState("RD");
//   const [activeSecondary, setActiveSecondary] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [accounts, setAccounts] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   // ✅ Fetch API Data
//   const fetchAccounts = async () => {
//     try {
//       setLoading(true);
//       const superAdminId = localStorage.getItem("superAdminId") || 14;

//       const res = await axios.get("https://narrowitsolution.in/api/deposit/list", {
//         params: {
//           superAdminId,
//           page: currentPage,
//           limit: rowsPerPage,
//           accountType: activeMainTab,
//           status: activeSecondary !== "All" ? activeSecondary : undefined,
//           search: searchQuery || undefined,
//         },
//       });

//       if (res.data.success) {
//         setAccounts(res.data.data || []);
//         setTotalPages(res.data.totalPages || 1);
//       } else {
//         setAccounts([]);
//       }
//     } catch (err) {
//       console.error("Error fetching deposit accounts:", err);
//       setAccounts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch whenever filters or page changes
//   useEffect(() => {
//     fetchAccounts();
//   }, [activeMainTab, activeSecondary, searchQuery, currentPage]);

//   // Reset page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [activeMainTab, activeSecondary]);

//   // Render Table
//   const renderTable = useMemo(() => {
//     if (loading) {
//       return (
//         <tr>
//           <td colSpan="10" style={{ textAlign: "center" }}>
//             Loading...
//           </td>
//         </tr>
//       );
//     }

//     if (!accounts.length) {
//       return (
//         <tr>
//           <td colSpan="10" style={{ textAlign: "center" }}>
//             No Data Found
//           </td>
//         </tr>
//       );
//     }

//     return accounts.map((acc, index) => (
//       <tr key={acc.id}>
//         <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//         <td>{acc.accountNo}</td>
//         <td>{acc.customerName || "--"}</td>
//         <td>{acc.accountType || "--"}</td>
//         <td>{acc.roi || "--"}%</td>
//         <td>₹{acc.minDeposit || 0}</td>
//         <td>₹{acc.loanAmount || 0}</td>
//         <td>{acc.lockinPeriod || 0}</td>
//         <td>{acc.referId || "--"}</td>
//         <td>{acc.nomineeId || "--"}</td>
//         <td>
//           <button
//             className="DDFDReportview-btn"
//             onClick={() => alert(`Viewing ${acc.accountNo}`)}
//           >
//             View
//           </button>
//         </td>
//       </tr>
//     ));
//   }, [accounts, loading, currentPage]);

//   return (
//     <div className="DDFDReport-container">
//       <h2 style={{ textAlign: "center", marginBottom: 10 }}>
//         {activeMainTab} Account Report
//       </h2>

//       {/* Tabs */}
//       <div className="DDFDReport-main-tabs">
//         {["RD", "DD"].map((tab) => (
//           <button
//             key={tab}
//             className={`DDFDReport-main-btn ${
//               activeMainTab === tab ? "active" : ""
//             }`}
//             onClick={() => setActiveMainTab(tab)}
//           >
//             {tab} Report
//           </button>
//         ))}
//       </div>

//       {/* Secondary Tabs */}
//       <div className="DDFDReport-secondary-tabs">
//         {secondaryTabs.map((tab) => (
//           <button
//             key={tab}
//             className={`DDFDReport-secondary-btn ${
//               activeSecondary === tab ? "active" : ""
//             }`}
//             onClick={() => setActiveSecondary(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Search */}
//       <div className="DDFDReportsearch-box">
//         <input
//           type="text"
//           placeholder="Search by Account No / Customer..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>
// {/* Table */}
// <div className="DDFDReporttable-container">
//   <table className="DDFDReport-table">
//     <thead>
//       <tr>
//         <th>SN</th>
//         <th>Account No</th>
//         <th>Customer Name</th>
//         <th>Account Type</th>
//         <th>Status</th>               {/* NEW */}
//         <th>Roi</th>
//         <th>Deposit Amount</th>       {/* NEW */}
//         <th>Tenure</th>               {/* NEW */}
       
//         {/* <th>Nominee ID</th> */}
//         <th>Action</th>
//       </tr>
//     </thead>

//     <tbody>
//       {loading ? (
//         <tr>
//           <td colSpan="14" style={{ textAlign: "center" }}>Loading...</td>
//         </tr>
//       ) : accounts.length === 0 ? (
//         <tr>
//           <td colSpan="14" style={{ textAlign: "center" }}>No Data Found</td>
//         </tr>
//       ) : (
//         accounts.map((acc, index) => (
//           <tr key={acc.id}>
//             <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//             <td>{acc.accountNo}</td>
//             <td>{acc.customerName || "--"}</td>
//             <td>{acc.accountType || "--"}</td>

//             {/* NEW STATUS FIELD */}
//             <td>{acc.status || "--"}</td>

//             <td>{acc.roi || "--"}%</td>

//             {/* NEW DEPOSIT AMOUNT */}
//             <td>₹{acc.amount || acc.minDeposit || 0}</td>

//             {/* NEW TENURE */}
//             <td>{acc.tenure || "--"}</td>

         
//             {/* <td>{acc.nomineeName || "--"}</td> */}

//             <td>
//               <button
//                 className="DDFDReportview-btn"
//                 onClick={() => alert(`Viewing ${acc.accountNo}`)}
//               >
//                 View
//               </button>
//             </td>
//           </tr>
//         ))
//       )}
//     </tbody>
//   </table>
// </div>


//       {/* Pagination */}
//       <div className="DDFDReportpagination">
//         <button
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((p) => p - 1)}
//         >
//           Previous
//         </button>
//         <span>
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((p) => p + 1)}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default RdDdReport;

import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/RdDdReport.css";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
const secondaryTabs = ["All", "Active", "Closed", "Pre-Closed", "Reject"];
const rowsPerPage = 10;



const RdDdReport = () => {
  const [activeMainTab, setActiveMainTab] = useState("RD");
  const [activeSecondary, setActiveSecondary] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
//   const slipRef = useRef(null);
//   const [selectedAcc, setSelectedAcc] = useState(null);

//   useEffect(() => {
//   if (selectedAcc) {
//     setTimeout(() => {
//       handlePrint();
//     }, 50);
//   }
// }, [selectedAcc]);



  // const handlePrint = useReactToPrint({
  //   contentRef: slipRef,    
  //   documentTitle: "Slip",
  //   pageStyle: `
  //     @page { size: 58mm auto; margin: 0; }
  //     body { -webkit-print-color-adjust: exact; }
  //   `,
  // });



  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Dialog States
  const [showDialog, setShowDialog] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [approveLoading, setApproveLoading] = useState(false);

  // ============================
  // ✅ Fetch Deposit Accounts
  // ============================
  const fetchAccounts = async () => {
    try {
      setLoading(true);

  const superAdminId = Number(localStorage.getItem('adminuserId')) || 0;

      const res = await axios.get("https://narrowitsolution.in/api/deposit/list", {
        params: {
          superAdminId,
          page: currentPage,
          limit: rowsPerPage,
          accountType: activeMainTab,
          status: activeSecondary !== "All" ? activeSecondary : undefined,
          search: searchQuery || undefined,
        },
      });

      if (res.data.success) {
        setAccounts(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
      }
    } catch (err) {
      console.error(err);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchAccounts();
  }, [activeMainTab, activeSecondary, searchQuery, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeMainTab, activeSecondary]);

  // ============================
  // 🟢 Open Approve Modal
  // ============================
  const openApproveDialog = (account) => {
    setSelectedAccount(account);
    setShowDialog(true);
  };

  // ============================
  // 🟢 Approve API
  // ============================
  const approveAccount = async () => {
    try {
      setApproveLoading(true);

      const employee = localStorage.getItem("adminuserId") || "Admin";

      const res = await axios.post(
        "https://narrowitsolution.in/api/deposit-account/approve",
        {
          accountId: selectedAccount.id,
          approvedBy: employee,
          remarks: "Approved from RD/DD report",
        }
      );

      if (res.data.success) {
        alert("Account Approved Successfully!");
        setShowDialog(false);
        fetchAccounts(); // Refresh list
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Approval failed.");
    } finally {
      setApproveLoading(false);
    }
  };

  return (
    <div className="DDFDReport-container">
        <h2 style={{ textAlign: "center", marginBottom: 10 }}>
          {activeMainTab} Account Report
        </h2>

        {/* Tabs */}
        <div className="DDFDReport-main-tabs">
          {["RD", "DD"].map((tab) => (
            <button
              key={tab}
              className={`DDFDReport-main-btn ${
                activeMainTab === tab ? "active" : ""
              }`}
              onClick={() => setActiveMainTab(tab)}
            >
              {tab} Report
            </button>
          ))}
        </div>

        {/* Secondary Tabs */}
        <div className="DDFDReport-secondary-tabs">
          {secondaryTabs.map((tab) => (
            <button
              key={tab}
              className={`DDFDReport-secondary-btn ${
                activeSecondary === tab ? "active" : ""
              }`}
              onClick={() => setActiveSecondary(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        
      {/* SEARCH */}
      <div className="DDFDReportsearch-box">
        <input
          type="text"
          placeholder="Search by Account No / Customer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* TABLE */}
      <div className="DDFDReporttable-container">
        <table className="DDFDReport-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer</th>
              <th>Type</th>
              <th>Status</th>
              <th>ROI</th>
              <th>Amount</th>
              <th>Tenure</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : accounts.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            ) : (
              accounts.map((acc, index) => (
                <tr key={acc.id}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{acc.accountNo}</td>
                  <td>{acc.customerName || "--"}</td>
                  <td>{acc.accountType}</td>
                  <td>{acc.status}</td>
                  <td>{acc.roi}%</td>
                  <td>₹{acc.amount}</td>
                  <td>{acc.tenure}</td>

                  <td>
                    <button
                      className="DDFDReportview-btn"
                      onClick={() => alert(`View ${acc.accountNo}`)}
                    >
                      View
                    </button>

                    {acc.status === "Pending" && (
                      <button
                        className="approve-btn"
                        onClick={() => openApproveDialog(acc)}
                      >
                        Approve
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <div className="DDFDReportpagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>

      {/* APPROVE MODAL */}
      {showDialog && selectedAccount && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <h3>Approve Deposit Account</h3>

            <p><b>Account No:</b> {selectedAccount.accountNo}</p>
            <p><b>Name:</b> {selectedAccount.customerName}</p>
            <p><b>Amount:</b> ₹{selectedAccount.amount}</p>
            <p><b>Tenure:</b> {selectedAccount.tenure} </p>
            <p><b>Status:</b> {selectedAccount.status}</p>

            <div className="dialog-actions">
              <button onClick={() => setShowDialog(false)}>Close</button>

              <button
                className="approve-btn"
                onClick={approveAccount}
                disabled={approveLoading}
              >
                {approveLoading ? "Approving..." : "Approve"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RdDdReport;
